'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = editingNavigationItem;

var _actions = require('../actions');

function editingNavigationItem() {
  var currentEditingNavigationItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case _actions.ADD_LINK:
      return {
        id: null,
        type: 'link',
        navigation_section_id: action.navigationSectionId,
        title: '',
        page_id: null
      };
    case _actions.ADD_SECTION:
      return {
        id: null,
        type: 'section',
        title: ''
      };
    case _actions.CANCEL_EDITING_NAVIGATION_ITEM:
      return null;
    case _actions.CHANGE_EDITING_NAVIGATION_ITEM:
      return _extends({}, currentEditingNavigationItem, action.newProps);
    case _actions.COMMIT_EDITING_NAVIGATION_ITEM_SUCCESS:
      return null;
    case _actions.EDIT_NAVIGATION_ITEM:
      return _extends({}, action.navigationItem);
    default:
      return currentEditingNavigationItem;
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/cadmus-navbar-admin/lib/reducers/editingNavigationItem.js
// module id = 422
// module chunks = 0